module.exports = __webpack_public_path__ + "img/pre-arrow-black.48ee66cd.svg";